import axios from 'axios';
import { apiUrl } from './ApiHost';
import authHeader from './AuthHeader';

class ClientService {

  getClients() {
    return axios.get(apiUrl + 'clients', { headers: authHeader() });
  }

  getClientsShort() {
    return axios.get(apiUrl + 'clients/short', { headers: authHeader() });
  }

  getClientsThatNeedAPlan() {
    return axios.get(apiUrl + 'dashboard', { headers: authHeader() });
  }

  getClient(id) {
    return axios.get(apiUrl + 'clients/' + id, { headers: authHeader() });
  }

  addClient(client) {
    return axios.post(apiUrl + 'clients', client, { headers: authHeader() });
  }

  updateClient(client) {
    return axios.put(apiUrl + 'clients', client, { headers: authHeader() });
  }

  deleteClient(id) {
    return axios.delete(apiUrl + 'clients/' + id, { headers: authHeader() });
  }

  getMeasurements(clientId) {
    return axios.get(apiUrl + 'clients/bioimpedance/' + clientId, { headers: authHeader() });
  }

  addMeasurement(clientId, measurement) {
    return axios.post(apiUrl + 'clients/bioimpedance/' + clientId, measurement, { headers: authHeader() });
  }

  updateMeasurement(clientId, measurement) {
    return axios.put(apiUrl + 'clients/bioimpedance/' + clientId, measurement, { headers: authHeader() });
  }

  deleteMeasurement(clientId, id) {
    return axios.delete(apiUrl + 'clients/bioimpedance/' + clientId + '/' + id, { headers: authHeader() });
  }

}

export default new ClientService();